import { Toggle as TogglePrimitive } from "@base-ui/react/toggle";
import { ToggleGroup as ToggleGroupPrimitive } from "@base-ui/react/toggle-group";
import * as React from "react";

import { toggleClassName, type ToggleLook } from "@beweegbaas/ui/components/ui/toggle";
import { cnState } from "@beweegbaas/ui/lib/utils";

const ToggleGroupContext = React.createContext<ToggleLook>({});

/**
 * Toggles that belong together: one of them pressed at a time, or any number with `multiple`. The
 * arrow keys move between them, so the group is a single stop for the Tab key. Its `variant` and
 * `size` are the look of every item in it.
 */
function ToggleGroup<Value extends string>({
  variant,
  size,
  className,
  ...props
}: ToggleGroupPrimitive.Props<Value> & ToggleLook) {
  return (
    <ToggleGroupContext.Provider value={{ variant, size }}>
      <ToggleGroupPrimitive
        data-slot="toggle-group"
        className={cnState("flex flex-wrap gap-1.5", className)}
        {...props}
      />
    </ToggleGroupContext.Provider>
  );
}

function ToggleGroupItem<Value extends string>({
  variant,
  size,
  className,
  ...props
}: TogglePrimitive.Props<Value> & ToggleLook) {
  const group = React.useContext(ToggleGroupContext);
  return (
    <TogglePrimitive
      data-slot="toggle-group-item"
      className={toggleClassName(
        { variant: variant ?? group.variant, size: size ?? group.size },
        className,
      )}
      {...props}
    />
  );
}

export { ToggleGroup, ToggleGroupItem };
